/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./manage-fine-type.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./manage-fine-type.component";
var styles_ManageFineTypeComponent = [i0.styles];
var RenderType_ManageFineTypeComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ManageFineTypeComponent, data: {} });
export { RenderType_ManageFineTypeComponent as RenderType_ManageFineTypeComponent };
export function View_ManageFineTypeComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" manage-fine-type works!\n"]))], null, null); }
export function View_ManageFineTypeComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-manage-fine-type", [], null, null, null, View_ManageFineTypeComponent_0, RenderType_ManageFineTypeComponent)), i1.ɵdid(1, 114688, null, 0, i2.ManageFineTypeComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ManageFineTypeComponentNgFactory = i1.ɵccf("app-manage-fine-type", i2.ManageFineTypeComponent, View_ManageFineTypeComponent_Host_0, {}, {}, []);
export { ManageFineTypeComponentNgFactory as ManageFineTypeComponentNgFactory };
